module.exports = __webpack_public_path__ + "img/06-0资质9.ceb82981.png";